import React from 'react'
import ClusterListCard from '@/components/ClusterListCard'

export default function OrganizationClusters() {
    return <ClusterListCard />
}
